import { Box, Text, Image, Badge, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Center, Spinner, Flex, } from '@chakra-ui/react';
import MyDiv from './jobOpeningsCard.style'
import ArrowIcon from "../../../../../assets/images/ActionArrow.svg";
import { useNavigate } from "react-router";
import * as routesNames from '../../../../../constants/routes';
import { CustomPagination, CustomTable, CustomToast } from '../../../../../components';
import { ILazyParams, useFetch } from '../../../../../hooks/useFetch';
import { useEffect, useState } from 'react';
import { Column } from '../../../../../components/CustomTable/customTable';
import { showDate } from '../../../../../utilities/helper';

interface jobOpeningsProps {
    selectedDate: Date;
}

const JobOpeningsCard = ({ selectedDate }: jobOpeningsProps) => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const navigate = useNavigate();

    const candidateList = (jobId: any) => {
        navigate(routesNames.CANDIDATELIST, { state: { jobId: jobId.id, Job_profile: jobId.job_Profile_Name } });
    }



    const [jobOpenings, setJobOpenings] = useState<any[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [query, setQuery] = useState<{ lazyParams: ILazyParams, }>({ lazyParams: { first: 0, rows: 10, page: 0, sortField: '', sortOrder: 1, }, });


    const pageCount = Math.ceil(totalCount / query.lazyParams.rows);
    const handlePageClick = ({ selected }: { selected: number }) => {
        setQuery(prev => {
            const updatedParams = {
                ...prev.lazyParams,
                page: selected,
                first: selected * prev.lazyParams.rows,
            };
            return { ...prev, lazyParams: updatedParams };
        });
    };

    const setRowsPerPage = (rows: number) => {
        setQuery((prev) => {
            const updatedParams = {
                ...prev.lazyParams,
                rows,
                page: 0,
                first: 0,
            };
            return { ...prev, lazyParams: updatedParams };
        });
    };


    const loadJobOpenin = async () => {
        const formattedDate = selectedDate.getMonth() + 1;
        const selectedYear = selectedDate.getFullYear();
        const response = await fetchApi("RecruitmentDashboard/JobOpenings", "GET", "", `lazyParams=${JSON.stringify(query.lazyParams)}&selectedDate=${formattedDate}&selectedYear=${selectedYear}`, "");
        if (response) {
            setJobOpenings(response.recruitment);
            setTotalCount(response.totalRecords);
        }
    }

    useEffect(() => {
        loadJobOpenin();
    }, [query.lazyParams, selectedDate]);

    return (
        <MyDiv>
            <Box>
                <Box position="relative" minH="300px">
                    {loading ? (
                        <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                        </Center>) : (
                        <>
                            <CustomTable value={jobOpenings}>
                                <Column header="S. No" body={(_, index) => index + 1} />
                                <Column
                                    header="Job Title"
                                    body={(row: any) => (
                                        <Badge
                                            variant="subtle"
                                            className="job font-poppins text_sm text_regular"
                                            textAlign="center"
                                            onClick={() => candidateList(row)}
                                        >
                                            {row.job_Profile_Name}
                                        </Badge>
                                    )}
                                />

                                <Column header="Payroll Company" field="payroll_Company_Name" />
                                <Column header="Branch" field="branch_Name" />
                                <Column header="Department" field="department_Name" />
                                <Column header="Openings" field="number_Of_Openings" />

                                <Column
                                    header="Status"
                                    body={(row: any) => (
                                        <Badge
                                            backgroundColor={row.status === true ? '#E5F2E5' : '#FF00001A'}
                                            color={row.status === true ? '#008000' : '#FF0000'}
                                            px={3} py={1} borderRadius="6px"
                                        >
                                            <Text className='font-poppins text_regular text_sm' textAlign='center'>{row.status === true ? 'Active' : "Closed"}</Text>
                                        </Badge>
                                    )}
                                />
                                <Column header="Job Opening Date" field="job_Opening_Date" body={r => showDate(r.job_Opening_Date)} />
                                <Column header="Job Closing Date" field="job_Closing_Date" body={r => showDate(r.job_Closing_Date)} />
                                <Column header="Created By" field="createdBy" />
                                <Column
                                    header="Action"
                                    body={(row: any) => (
                                        <Image src={ArrowIcon} alt="Action" cursor="pointer" onClick={() => candidateList(row)} />
                                    )}
                                />
                            </CustomTable>

                        </>)}
                </Box>
                <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPageOptions={[10, 50, 100, 200]} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} />
            </Box>
        </MyDiv>
    )
}

export default JobOpeningsCard;
